/**
 * HistogramEditor
 *
 * Property editor for histogram configuration
 */

import React from 'react';
import { ChartBaseEditor, type ChartBaseConfig } from './ChartBaseEditor';
import { TextPropertyEditor } from '../../BaseEditors/TextPropertyEditor';
import { NumberPropertyEditor } from '../../BaseEditors/NumberPropertyEditor';

export interface HistogramEditorProps {
  config: Partial<ChartBaseConfig & {
    dataKey?: string;
    bins?: number;
    showFrequency?: boolean;
  }>;
  onChange: (config: Partial<ChartBaseConfig>) => void;
}

export const HistogramEditor: React.FC<HistogramEditorProps> = ({ config, onChange }) => {
  return (
    <ChartBaseEditor config={config} onChange={onChange} chartType="Histogram" showAxes>
      <div className="chart-editor__section">
        <h3 className="chart-editor__section-title">Histogram Options</h3>

        <TextPropertyEditor
          label="Data Key"
          value={(config.dataKey as string) || 'value'}
          onChange={(dataKey) => onChange({ ...config, dataKey })}
          helpText="Property with numeric values"
          required
        />

        <NumberPropertyEditor
          label="Number of Bins"
          value={(config.bins as number) || 10}
          onChange={(bins) => onChange({ ...config, bins })}
          min={3}
          max={50}
          step={1}
          helpText="How many bars to divide data into"
        />

        <div className="chart-editor__checkbox">
          <input
            type="checkbox"
            id="show-frequency"
            checked={(config.showFrequency as boolean) !== false}
            onChange={(e) => onChange({ ...config, showFrequency: e.target.checked })}
            className="af-property-editor__checkbox"
          />
          <label htmlFor="show-frequency">Show Frequency Labels</label>
        </div>
      </div>
    </ChartBaseEditor>
  );
};

HistogramEditor.displayName = 'HistogramEditor';
